import React from 'react'
import { useTranslation } from 'react-i18next'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import ErrorFallback from '../ErrorFallback'
import styles from './styles.module.scss'

function ServerErrorPage() {
  const { t } = useTranslation()
  return (
    <PageContainer pageTitle={t('errorPage.serverTitle')}>
      <ErrorFallback title={t('errorPage.serverTitle')} className={styles.container} />
    </PageContainer>
  )
}

export default ServerErrorPage
